import EmailBlasterLayout from '../components/layouts/EmailBlasterLayout.vue';
import EmailBlasterIndexPage from '../pages/EmailBlasterIndexPage.vue';
import EmailCampaignContactsImportPage from '../pages/EmailCampaignContactsImportPage.vue';

/**
 * @type {import('vue-router').RouteRecordRaw[]}
 */
export default [
    {
        // This is the parent route for your package.
        // It uses the layout component.
        path: '/email-blaster',
        name: 'email-blaster.root',
        component: EmailBlasterLayout,
        meta: {
            // e.g., requiresAuth: true
            // requiresAuth: true,
            // title: 'emailBlaster.nav.title',
            // layout: 'Authenticated',
        },
        // All other package routes are children of this layout
        children: [
            {
                // Child path is empty, so it renders at /email-blaster
                path: '',
                name: 'EmailBlasterIndexPage',
                component: EmailBlasterIndexPage,
            },
            {
                path: 'campaign-contacts/import',
                name: 'EmailCampaignContactsImportPage',
                component: EmailCampaignContactsImportPage,
            },
            // --- Example of other child routes ---
            // {
            //   path: 'create', // Renders at /email-blaster/create
            //   name: 'email-blaster.create',
            //   component: () => import('../components/Create.vue'),
            // },
        ]
    }
];
